/* eslint-disable max-len */
import { useMemo, useState } from 'react';

import { useScreenClass } from 'react-grid-system';
import { Col, Row } from '../components/StyledGridSystem';
import FlexBox, { FlexGrow } from '../components/FlexBox';
import iframeCode from '../helptest';
function HelpPage() {
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ['xs', 'sm'].includes(screenClass),
    [screenClass],
  );
  // const { t, i18n } = useTranslation()
  const [tab, setTab] = useState(0);
  return (
    <>
      <Row>
        <Col>
          <FlexBox>
            <FlexGrow>
              <div dangerouslySetInnerHTML={{ __html: iframeCode }} />
            </FlexGrow>
          </FlexBox>
        </Col>
      </Row>
    </>
  );
}
export default HelpPage;
